import classNames from 'classnames'
import { ProductTag } from 'shared-types'
import Tag from '~/components/Tag'
import TagImage from '~/components/TagImage'
import styles from '../ProductCard.module.css'

export type ProductCardTagProps = {
  tag: ProductTag
  /**
   * Extra class for the tag, used to colour it like the price badge
   */
  className?: string
}

export const ProductCardTag = ({ tag, className }: ProductCardTagProps) => {
  const { labelImageUrl, desc, backgroundColor, color } = tag

  if (labelImageUrl?.title && labelImageUrl?.href) {
    return <TagImage href={labelImageUrl.href} title={labelImageUrl.title} />
  }

  if (!desc) {
    return null
  }

  return (
    <Tag
      variant='primary'
      backgroundColor={backgroundColor}
      color={color}
      theme={{
        success: classNames(styles.tag, className),
      }}>
      <span className={classNames(styles.tag, 'uppercase')}>{desc}</span>
    </Tag>
  )
}
